module.exports = __webpack_public_path__ + "assets/images/airports/desktop.svg?v=0fe6e4bf";